import dayjs from 'dayjs';

export function formatTraceDuration(milliseconds: number | null) {
  if (milliseconds == null) return 'Unfinished';
  if (!Number.isFinite(milliseconds) || milliseconds < 0) return 'Unavailable';
  return milliseconds < 1000 ? `${Math.round(milliseconds)} ms` : `${(milliseconds / 1000).toFixed(2)} s`;
}

export function formatTraceTime(timestamp: string) {
  const date = dayjs(timestamp);
  return date.isValid() ? date.toISOString() : 'Unavailable';
}
